import Page from '@/components/pages/category/category-page-controller';
import getStaticPaths from '@/components/pages/category/category-page-static-paths';
import getStaticProps from '@/components/pages/category/category-page-static-props';

export default Page;
export { getStaticProps, getStaticPaths };
